import React, { useState } from 'react';
import axios from 'axios';
import { API } from '../config';

const GraduationCard = ({ journey, onResolve }) => {
  const [resolving, setResolving] = useState(false);

  const handleResolve = async (decision) => {
    setResolving(true);
    try {
      const res = await axios.post(`${API}/journey/graduate`, { decision });
      if (onResolve) onResolve(decision, res.data);
    } catch (err) {
      alert('Failed to process. Please try again.');
    }
    setResolving(false);
  };

  const targetDays = journey?.target_days || 14;

  return (
    <div className="bg-emerald-50 border border-emerald-200 rounded-2xl p-6 shadow-sm text-center">
      <span className="text-5xl">🎉</span>
      <h3 className="text-2xl font-bold text-emerald-900 mt-3 mb-2">Journey Complete!</h3>
      <p className="text-emerald-700 mb-6">
        You showed up for <strong>{targetDays} days</strong>. You are becoming the person who{' '}
        <em>{journey?.identity_goal}</em>.
      </p>

      <div className="space-y-3">
        <button
          onClick={() => handleResolve('extend')}
          disabled={resolving}
          className="w-full py-4 px-4 bg-white border border-emerald-200 text-emerald-800 font-medium rounded-xl hover:bg-emerald-50 transition flex items-center justify-center gap-2 disabled:opacity-50"
        >
          <span>⚓</span> Keep doing this habit (Extend 14 Days)
        </button>

        <button
          onClick={() => handleResolve('evolve')}
          disabled={resolving}
          className="w-full py-4 px-4 bg-emerald-600 text-white font-bold rounded-xl shadow-md hover:bg-emerald-700 transition flex items-center justify-center gap-2 disabled:opacity-50"
        >
          <span>🚀</span> Level Up (Make it Harder)
        </button>

        <button
          onClick={() => handleResolve('complete')}
          disabled={resolving}
          className="w-full py-3 px-4 text-sm text-emerald-600 hover:text-emerald-800 disabled:opacity-50"
        >
          I'm done for now (Take a Break)
        </button>
      </div>
    </div>
  );
};

export default GraduationCard;
